import "./Footer.css";
import icon11 from "../Icons/Icon-11.png";
import icon12 from "../Icons/Icon-12.png";
import icon13 from "../Icons/Icon-13.png";
import icon14 from "../Icons/Icon-14.png";
import icon15 from "../Icons/Icon-15.png";
import icon16 from "../Icons/Icon-16.png";
import appStore from '../Icons/appstore.png'
import google from '../Icons/googleplay.png'
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Register from "../Register/Register";
import { showRegister } from "../Redux/HomeSlice";
import { useDispatch } from "react-redux";
import { searsh_brand } from "../Redux/API";

function Footer(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const gotoAbout = () => {
    navigate("/About");
    window.scrollTo(0, 0);
  
  };
  const gotoContact = () => {
    navigate("/Contact");
    window.scrollTo(0, 0);
  
  };
  const gotoStoresFooter = () => {
    navigate("/StoresFooter");
    window.scrollTo(0, 0);
  
  };
  const gotoCareers = () => {
    navigate("/Careers");
    window.scrollTo(0, 0);
  
  };

  const getLocalStorage = window.localStorage.getItem("UserInfo");
  const valueLocalStorage = getLocalStorage
    ? JSON.parse(getLocalStorage)
    : null;
  const token =
    valueLocalStorage?.data?.token ||
    valueLocalStorage?.data?.data?.user?.token ||
    null;

  const handleSignUp = (event) => {
    if (!token) {
      dispatch(showRegister(true));
      props.Sign_Up(event);
    }
  };
  return (
    <div className={`Footer`}>
      <div className="hr"></div>

      <div className={`fooater container-fluid`}>
        <div className="row align-items-center justify-content-between">
          <div className="div1 col-12 sm-6 col-md-5 col-lg-4">
            <p onClick={gotoAbout}>{t("About Us")}</p>
            <p onClick={gotoCareers}>{t("Careers")}</p>
            <p onClick={gotoContact}>{t("Contact US")}</p>
            <p onClick={gotoStoresFooter}>{t("Stores")}</p>
          </div>
          <div className="div2 col Sm-6 col-md-5 col-lg-4">
            <div>
              <a href="mailto:Contact@ashtiri.com?subject=Your%20Subject%20Here&body=Hello%2C%20this%20is%20a%20message%20body.">
                <span className="span1">{t("E-mail")}</span>
              </a>

              <span className="span2" onClick={(event) => handleSignUp(event)}>
                {t("Sign Up")}
              </span>
            </div>
            <div>
              <div>
                  <img src={appStore} />
              </div>
              <div>
                  <img src={google} />
              </div>
            </div>
          </div>
          <div className="div3 col-12 sm-12 col-md-12 col-lg-4">
            <a
              href="https://dashcontrol.ashtiri.com/"
              className="text-decoration-none"
            >
              <p className="col-12">{t("SELL ON ASHTIRI")}</p>
            </a>
            <p className="mt-xl-4">{t("follow Us On")}</p>
            <div>
              <a href="https://www.facebook.com/profile.php?id=61561822240808">
                <img src={icon11} />
              </a>
              <a href="https://www.instagram.com/ashtiri.kw?igsh=a3IwYmMwOHZyejBk">
                <img src={icon12} />
              </a>
              <a href="https://x.com/Ashtiri_KW">
                <img src={icon13} />
              </a>
              <a href="">
                <img src={icon14} />
              </a>
              <a href="https://www.youtube.com/channel/UC6fL1RWQeDE8S5HAoKB7vGw">
                <img src={icon15} />
              </a>
              <a href="https://www.pinterest.com/Ashtiri/">
                <img src={icon16} />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="copy">Copyright &copy; 2024 Ashtiri</div>
    </div>
  );
}

export default Footer;
